import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=177fc25e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=177fc25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177fc25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177fc25e')) {
      api.createRecord('177fc25e', component.options)
    } else {
      api.reload('177fc25e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=177fc25e&scoped=true&", function () {
      api.rerender('177fc25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4WCkzjDt3JOCb/JS/comp/CookieBox.vue"
export default component.exports